import type {ISceneManager} from "#template/interfaces/scene-manager"
import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"
import type {NodeClassImpl} from "#template/runtime-graph/types"
import type {DataObjectWithRelated} from "@cm/utils"
import type {Subscription} from "rxjs"
import {defer, map} from "rxjs"

const TD = TypeDescriptors

const fetchHdriDataObjectDescriptor = {
    sceneManager: TD.inlet(TD.Identity<ISceneManager>()),
    hdriId: TD.inlet(TD.Number),
    dataObject: TD.outlet(TD.DataObject),
}

export class FetchHdriDataObject implements NodeClassImpl<typeof fetchHdriDataObjectDescriptor, typeof FetchHdriDataObject> {
    static descriptor = fetchHdriDataObjectDescriptor
    static uniqueName = "FetchHdriDataObject"
    sceneManager!: Inlet<ISceneManager>
    hdriId!: Inlet<number>
    dataObject!: Outlet<DataObjectWithRelated>

    private pending: Subscription | null = null

    run() {
        this.cleanup()

        if (this.sceneManager === NotReady || this.hdriId === NotReady) {
            this.dataObject.emitIfChanged(NotReady)
            return
        }

        const {sceneManager, hdriId} = this

        this.pending = this.sceneManager.addTask({
            description: `loadHdriDataObject(${this.hdriId})`,
            task: defer(() => sceneManager.getResolver().hdriObjectLegacy(hdriId)).pipe(
                map((dataObject) => {
                    this.dataObject.emitIfChanged(dataObject)
                }),
            ),
            critical: true,
        })
    }

    cleanup() {
        this.pending?.unsubscribe()
        this.pending = null
    }
}
